export default "__VITE_ASSET__2ee31f06__"